import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@workspace/frontend-ui";
import { type FC, useRef } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import { KEEP_OPEN_ATTRIBUTE } from "../../constants";
import RewardsButton from "../RewardsButton";
import RewardCenter from "./RewardCenter";

const RewardCenterPopover: FC = () => {
  const {
    state: { progress, button, visibility },
    send,
  } = useRewardCenter();

  const anchorRef = useRef<HTMLSpanElement>(null);

  const handleInteractOutside = (event: Event) => {
    if (
      event.target instanceof Element &&
      event.target.closest(`[${KEEP_OPEN_ATTRIBUTE}]`)
    ) {
      event.preventDefault();
    }
  };

  return (
    <Popover
      open={visibility?.isOpen}
      onOpenChange={() => {
        send("rewardCenter", { type: "toggleVisibility" });
      }}
    >
      <PopoverTrigger asChild>
        <span className="inline-flex" ref={anchorRef}>
          <RewardsButton
            progress={progress ?? 0}
            status={button?.hasClaimable ? "claimable" : "none"}
            expanded={visibility?.isOpen}
          />
        </span>
      </PopoverTrigger>
      <PopoverContent
        data-slot="reward-center"
        align="end"
        sideOffset={8}
        className="w-106 rounded-3xl bg-background p-4 shadow-2xl"
        onInteractOutside={handleInteractOutside}
      >
        <RewardCenter />
      </PopoverContent>
    </Popover>
  );
};

export default RewardCenterPopover;
